/** Display/storage: always 10-digit local number (no +91, spaces, etc.). */
export function normalizePhone(phoneLike) {
  const digits = String(phoneLike ?? "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length >= 12 && digits.startsWith("91")) return digits.slice(-10);
  return digits.slice(-10);
}

export function formatPhoneDisplay(phoneLike) {
  return normalizePhone(phoneLike);
}

export function whatsappHref(phoneLike) {
  const last10 = normalizePhone(phoneLike);
  if (!last10) return "#";
  return `https://wa.me/91${last10}`;
}
